import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_AI_NOTES, SET_AI_NOTES_ERROR, SET_AI_NOTES_LOADING, SET_AI_NOTES_NEXT_SUMMARY_AT, SET_AI_NOTES_PANEL_VISIBLE, SET_AI_NOTES_SUMMARY } from './actionTypes';
import { AI_NOTES_FEATURE_KEY, AI_NOTES_TIMELINE_ID_PREFIX } from './constants';
const DEFAULT_STATE = {
    summary: null,
    timeline: [],
    loading: false,
    error: null,
    panelVisible: false,
    nextSummaryAt: null
};
/**
 * 是否有可展示的正文（空稿不入时间线）。
 *
 * @param {IAiNotesSummary | null} summary - Summary.
 * @returns {boolean}
 */
function hasDisplayableSummary(summary) {
    if (!summary) {
        return false;
    }
    const overview = String(summary.overview || '').trim();
    return Boolean(overview
        || summary.decisions?.length
        || summary.actionItems?.length
        || summary.chapters?.length);
}
/**
 * 与上一条是否同内容（避免轮询重复追加）。
 *
 * @param {IAiNotesTimelineEntry | undefined} prev - Previous entry.
 * @param {IAiNotesSummary} next - Incoming summary.
 * @returns {boolean}
 */
function isSameTimelineContent(prev, next) {
    if (!prev) {
        return false;
    }
    const prevOverview = String(prev.summary.overview || '').trim();
    const nextOverview = String(next.overview || '').trim();
    if (prevOverview !== nextOverview) {
        return false;
    }
    if (prev.summary.updatedAt && next.updatedAt && prev.summary.updatedAt === next.updatedAt) {
        return true;
    }
    return prevOverview.length > 0 && prevOverview === nextOverview
        && prev.summary.summaryMode === next.summaryMode;
}
/**
 * 将新纪要追加进时间线（有变化才追加）.
 *
 * @param {IAiNotesTimelineEntry[]} timeline - Current timeline.
 * @param {IAiNotesSummary} summary - New summary.
 * @returns {IAiNotesTimelineEntry[]}
 */
function appendTimelineEntry(timeline, summary) {
    if (!hasDisplayableSummary(summary)) {
        return timeline;
    }
    const last = timeline[timeline.length - 1];
    if (isSameTimelineContent(last, summary)) {
        return timeline;
    }
    const id = summary.updatedAt
        ? `${AI_NOTES_TIMELINE_ID_PREFIX}${summary.updatedAt}-${timeline.length}`
        : `${AI_NOTES_TIMELINE_ID_PREFIX}${Date.now()}-${timeline.length}`;
    return [
        ...timeline,
        {
            id,
            summary
        }
    ];
}
ReducerRegistry.register(AI_NOTES_FEATURE_KEY, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_AI_NOTES_SUMMARY: {
            const summary = action.summary;
            let timeline = state.timeline || [];
            if (summary === null) {
                timeline = [];
            }
            else {
                // 增量/总纪要均追加为新段落，不覆盖历史
                timeline = appendTimelineEntry(timeline, summary);
            }
            return {
                ...state,
                summary,
                timeline,
                error: null
            };
        }
        case SET_AI_NOTES_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SET_AI_NOTES_ERROR:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case SET_AI_NOTES_PANEL_VISIBLE:
            return {
                ...state,
                panelVisible: Boolean(action.visible)
            };
        case SET_AI_NOTES_NEXT_SUMMARY_AT:
            return {
                ...state,
                nextSummaryAt: typeof action.nextSummaryAt === 'number' ? action.nextSummaryAt : null
            };
        case CLEAR_AI_NOTES:
            return { ...DEFAULT_STATE };
        default:
            return state;
    }
});
